import { FC } from 'react';
import { Image } from '@sitecore-jss/sitecore-jss-nextjs';
import { sanitize } from 'isomorphic-dompurify';

import { icon_arrow_right } from '@gn-audio/icons';
import { JabraIcon } from '@gn-audio/jss-components';

import { CategoryPromoSlidesProps } from './categoryPromoSpotTypes';

const CategoryPromoSlides: FC<CategoryPromoSlidesProps> = ({ items, isActive }) => {
  const getGridClasses = (index: number, length: number) => {
    switch (length) {
      case 1:
        return 'col-span-2 row-span-2';
      case 2:
        return 'col-start-1 col-span-2 row-span-2';
      default:
        switch (index) {
          case 0:
            return 'col-span-1 row-span-1';
          case 1:
            return 'col-start-1 row-start-2';
          case 2:
            return 'col-span-1 row-span-2';
          default:
            return '';
        }
    }
  };
  return (
    <div className="relative flex h-full flex-col gap-4 sm:grid sm:grid-cols-2 sm:grid-rows-2">
      {items.map((item, index) => (
        <a
          key={item.id}
          href={item.link?.value?.href || undefined}
          tabIndex={isActive ? 0 : -1}
          {...(item.firstLinkTrackingName?.value && {
            'data-wt-name': item.firstLinkTrackingName.value,
          })}
          className={`relative block min-h-[500px] rounded-[24px] bg-gray-90 shadow-[0_5px_5px_-4px_rgba(0,0,0,0)] transition-all duration-300 ease-in-out hover:bg-gray-90/50 hover:shadow-[0_5px_5px_-4px_rgba(0,0,0,0.3)] ${getGridClasses(index, items.length)}`}
          aria-labelledby={`title-${item.id}`}
          aria-disabled={!isActive}
        >
          <Image
            className="absolute left-0 h-full w-full object-contain"
            field={item.image}
            loading="lazy"
          />
          <div className="absolute left-1/2 top-8 flex w-[calc(100%-2rem)] -translate-x-1/2 transform flex-col gap-3 text-center">
            <h3
              id={`title-${item.id}`}
              className="heading-5 mb-0"
              dangerouslySetInnerHTML={{ __html: sanitize(item.title.value) }}
            />
            <span
              className="text-base opacity-60"
              dangerouslySetInnerHTML={{ __html: sanitize(item.description.value) }}
            />
          </div>
          {!!item.link?.value?.href && (
            <div className="absolute bottom-4 left-1/2 flex w-[calc(100%-3.5rem)] -translate-x-1/2 transform justify-end text-right">
              <div className="h-12 min-w-12">
                <div className="flex h-full w-full items-center justify-between rounded-full border-2 border-[transparent] bg-primary font-bold transition-colors duration-300 ease-linear hover:bg-gray-700">
                  <div className="relative flex h-full w-11 items-center justify-center rounded-full bg-primary text-on-brand transition-colors duration-300 ease-linear hover:bg-gray-700 hover:text-white">
                    <JabraIcon Icon={icon_arrow_right} />
                  </div>
                </div>
              </div>
            </div>
          )}
        </a>
      ))}
    </div>
  );
};

export default CategoryPromoSlides;
